import { IRootState } from 'reducers';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const selfDiagnosticsYearsSelector = createSelector(
  (state: IRootState) => state.studentDiagnosis?.content,
  (selfDiagnostics) =>
    extractDatesFromNestedItems(selfDiagnostics, [
      {
        type: 'academicYearString',
        field: 'learningYear',
      },
    ]),
);
